import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Tariff_Floor_Interface } from 'src/app/Interface/Tariff_Floor_Interface';
import { Tariff_Interface } from 'src/app/Interface/Tariff_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TariffService {

  constructor(private http: HttpClient) { }


  GetRecord(deviceTitle: String, dsc: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff?deviceTitle=" + deviceTitle
      + "&dsc=" + dsc).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetTarrifFloor(): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetTarrifFloor").pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetHistoryFile(): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetHistoryFile").pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  GetHistory(id: number): Observable<Array<Tariff_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetHistory?id=" + id).pipe(
      map(data => {
        return data as Array<Tariff_Interface>
      })
    )
  }

  GetDeviceTariff(id: number, CustomerId: number): Observable<Array<Tariff_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetDeviceTariff?id=" + id + "&CustomerId=" + CustomerId).pipe(
      map(data => {
        return data as Array<Tariff_Interface>
      })
    )
  }

  GetDeviceTariff_By_Tariff_Id(id: number): Observable<Array<Tariff_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetDeviceTariff_By_Tariff_Id?id=" + id).pipe(
      map(data => {
        return data as Array<Tariff_Interface>
      })
    )
  }

  GetSingle(id: Number): Observable<Tariff_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetSingle?id=" + id).pipe(
      map(data => {
        return data as Tariff_Interface
      })
    )
  }

  uploadFile(body) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Tariff/upload", body).pipe(
      map(data => {
        return data
      })
    )
  }

  AddTariff(model: Tariff_Interface): Observable<Tariff_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      device_id: model.device_id,
      dsc: model.dsc,
      tariff: model.tariff,
      tariff_expert: model.tariff_expert,
      tariff_hazineh: model.tariff_hazineh,
      
      t1: model.t1,
      t2: model.t2,
      t3: model.t3,
      
      del: false,
      username: ''
    }


    return this.http.post(environment.BaseUrl + "Daro/Tariff/Add", body, { headers }).pipe(
      map(data => {
        return data as Tariff_Interface
      })
    )

  }

  AddTariffFloor(model: Tariff_Floor_Interface): Observable<Tariff_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    model.username = ''

    return this.http.post(environment.BaseUrl + "Daro/Tariff/AddTariffFloor", model, { headers }).pipe(
      map(data => {
        return data as Tariff_Interface
      })
    )

  }

  EditTariff(model: Tariff_Interface): Observable<Tariff_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      dsc: model.dsc,
      del: false,
      username: ''
    }


    return this.http.post(environment.BaseUrl + "Daro/Tariff/Edit", body, { headers }).pipe(
      map(data => {
        return data as Tariff_Interface
      })
    )

  }

  DeleteTariff(id: number): Observable<Tariff_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Tariff/Delete?id=" + id ).pipe(
      map(data => {
        return data as Tariff_Interface
      })
    )

  }

}
